import type { UnitTab } from '../units/units.paths';

/**
 * A truck's address by id, for a link that has only the id to hand: it opens the truck's unit on that tab (`RedirectToUnit`).
 * With the registration to hand, link with `unitPath` and skip the redirect.
 */
export function truckTabPath(id: string, tab: UnitTab): string {
  return `/fleet/trucks/${id}/${tab}`;
}
